import { Skeleton, TableCell, TableRow as MuiTableRow } from '@mui/material';

import { ColumnConfig } from '@/components/table/Table.tsx';

export type TableSkeletonProps = {
  columns: ColumnConfig[];
  renderActions?: (rowData: Record<string, any>) => React.ReactNode;
  skeletonRows: number;
  selectable?: boolean;
};

export const TableSkeleton = ({
  columns,
  renderActions,
  skeletonRows,
  selectable,
}: TableSkeletonProps) => {
  return (
    <>
      {Array.from({ length: skeletonRows }).map((_, index) => (
        <MuiTableRow
          key={index}
          style={{
            backgroundColor:
              index % 2 === 0 ? 'var(--light-gray)' : 'var(--white-color)',
          }}
        >
          {selectable && (
            <TableCell padding='checkbox' sx={{ width: '48px' }}>
              <Skeleton variant='rectangular' width={20} height={20} />
            </TableCell>
          )}
          {columns.map((column) => (
            <TableCell
              key={column.field}
              style={{
                color:
                  column.field === 'id' ? 'var(--primary-color)' : 'inherit',
              }}
            >
              <Skeleton variant='text' sx={{ fontSize: '1.5rem' }} />
            </TableCell>
          ))}
          {renderActions && (
            <TableCell>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '20px',
                }}
              >
                <Skeleton variant='circular' width={30} height={30} />
                <Skeleton variant='circular' width={30} height={30} />
              </div>
            </TableCell>
          )}
        </MuiTableRow>
      ))}
    </>
  );
};
